import Questionary from "@/views/Home/components/Questionary";
import ClaimHomeQuestionary from "./components/ClaimHomeQuestionary";

import { mapGetters } from "vuex";

export default {
  name: "home_owners",

  data() {
    return {
      isFixHeight: false
    };
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    })
  },

  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  },

  components: {
    Questionary,
    ClaimHomeQuestionary
  }
};
